import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { CreditCard } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { PagePlaceholder } from "@/components/common/PagePlaceholder";
import { Card, StatusBadge, btnPrimary, btnSecondary } from "@/components/common/Form";
import { LoadingState } from "@/components/common/States";

export function AdminOrders() {
  return <PagePlaceholder title="Order Management" description="Order dispatch monitoring, refunds, returns and shipment tracking." />;
}
export function AdminCustomers() {
  return <PagePlaceholder title="Customer Management" description="Customer accounts, business buyers, and support tools." />;
}
export function AdminSettings() {
  const [cfg, setCfg] = useState(null);
  const [showConnectors, setShowConnectors] = useState(false);
  useEffect(() => { api.get("/admin/settings/payment-gateway").then((r) => setCfg(r.data)).catch((e) => toast.error(formatApiError(e.response?.data?.detail))); }, []);
  const later = async () => {
    try { setCfg({ ...cfg, ...(await api.post("/admin/settings/payment-gateway/connect-later")).data }); toast.success("Payment gateway connection deferred"); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  if (!cfg) return <LoadingState />;
  return (
    <div className="space-y-6" data-testid="admin-settings-page">
      <Card title="Payments → Payment Gateway" subtitle="Connect a payment provider later. Orders are currently recorded with payment status PENDING." testId="payment-gateway-card">
        <div className="flex flex-wrap items-center gap-6 text-sm">
          <div className="h-12 w-12 rounded-lg bg-accent text-secondary grid place-items-center"><CreditCard size={22} /></div>
          <div>Status<div className="mt-1"><StatusBadge value={cfg.status} testId="payment-gateway-status" /></div></div>
          <div>Provider<div className="mt-1 font-semibold text-stone-900" data-testid="payment-gateway-provider">{cfg.provider === "NONE" ? "Not Connected" : cfg.provider}</div></div>
          <div>Mode<div className="mt-1 font-semibold text-stone-900" data-testid="payment-gateway-mode">{cfg.mode}</div></div>
        </div>
        <div className="mt-5 flex flex-wrap gap-2">
          <button onClick={() => setShowConnectors((s) => !s)} data-testid="explore-connectors-btn" className={btnPrimary}>Explore Connectors</button>
          <button onClick={later} data-testid="connect-later-btn" className={btnSecondary}>Connect Later</button>
        </div>
        {showConnectors && (
          <div className="mt-4 grid sm:grid-cols-2 gap-3" data-testid="connector-list">
            {cfg.supported_providers.map((p) => (
              <div key={p} className="rounded-lg border border-border p-4 text-sm">
                <div className="font-semibold text-stone-900">{p}</div>
                <p className="text-stone-500 mt-1">Available in a later step. Credentials will be configured as backend-only secrets — never stored in the database or exposed to the browser.</p>
                <span className="mt-2 inline-block text-[11px] font-medium text-secondary bg-secondary/5 rounded-full px-2 py-0.5">Not connected</span>
              </div>
            ))}
          </div>
        )}
      </Card>
      <PagePlaceholder title="Other Platform Settings" description="Commission, GST, currency, shipping, security and content configuration." />
    </div>
  );
}
